// extracted by mini-css-extract-plugin
module.exports = {"Orders":"styles_Orders__e3ndj","head":"styles_head__24e1t","row":"styles_row__cvqje","accordion":"styles_accordion__vyQco","orderDetails":"styles_orderDetails__5Wjts"};